import React from 'react';
import { CheckCircle, X } from 'lucide-react';
interface SuccessBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  data?: {
    employeeName: string;
    time: string;
    type: 'Time In' | 'Time Out';
  };
}
export function SuccessBottomSheet({
  isOpen,
  onClose,
  data
}: SuccessBottomSheetProps) {
  if (!isOpen || !data) return null;
  return <div className="fixed inset-0 z-50 flex items-end justify-center pointer-events-none" data-id="element-79">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 pointer-events-auto" onClick={onClose} data-id="element-80" />

      {/* Sheet */}
      <div className="bg-slate-800 w-full max-w-md rounded-t-2xl p-6 pb-8 pointer-events-auto animate-in slide-in-from-bottom duration-300" data-id="element-81">
        <div className="flex justify-center mb-6" data-id="element-82">
          <div className="w-12 h-1 bg-slate-600 rounded-full" data-id="element-83" />
        </div>

        <div className="flex flex-col items-center text-center" data-id="element-84">
          <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mb-4 text-green-500" data-id="element-85">
            <CheckCircle size={32} data-id="element-86" />
          </div>

          <h2 className="text-2xl font-bold text-white mb-1" data-id="element-87">Success!</h2>
          <p className="text-slate-400 mb-6" data-id="element-88">
            Attendance recorded successfully
          </p>

          <div className="bg-slate-700/50 rounded-xl p-4 w-full mb-6" data-id="element-89">
            <div className="text-sm text-slate-400 mb-1" data-id="element-90">Employee</div>
            <div className="text-lg font-semibold text-white mb-3" data-id="element-91">
              {data.employeeName}
            </div>

            <div className="flex justify-between items-center border-t border-slate-600 pt-3" data-id="element-92">
              <div data-id="element-93">
                <div className="text-xs text-slate-400" data-id="element-94">Type</div>
                <div className="text-blue-400 font-medium" data-id="element-95">{data.type}</div>
              </div>
              <div className="text-right" data-id="element-96">
                <div className="text-xs text-slate-400" data-id="element-97">Time</div>
                <div className="text-white font-mono text-xl" data-id="element-98">{data.time}</div>
              </div>
            </div>
          </div>

          <button onClick={onClose} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-lg transition-colors" data-id="element-99">
            Done
          </button>
        </div>
      </div>
    </div>;
}